module.exports = __webpack_public_path__ + "static/media/citizen.8bee1dfc.svg";